import type { BlockCMS } from '@/types'
import { getTranslate } from '@/utils/api-interceptors'
import Image from 'next/image'
import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'
interface ModuleTabScrollType {
  data: BlockCMS
  order: number
}
const ModuleTabScroll = ({ data }: ModuleTabScrollType) => {
  const [activeId, setActiveId] = useState('')
  const router = useRouter()
  const isBrowser = () =>
    typeof window !== 'undefined' || typeof document !== 'undefined'
  useEffect(() => {
    if (isBrowser()) {
      const valueAfterHash = window.location.hash.substring(1)
      return setActiveId(valueAfterHash)
    }
  }, [router])
  const scrollToHash = function (element_id: string) {
    if (isBrowser()) {
      const element = document.getElementById(element_id)
      element?.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'start',
      })
    }
  }
  useEffect(() => {
    const handleScroll = () => {
      const scrollPos =
        window.scrollY ||
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        0
      const element = document.querySelectorAll('section[id]')

      if (element !== null) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        element.forEach(function (section: any) {
          const sectionTop = section?.offsetTop - 30
          const sectionBottom = sectionTop + section?.offsetHeight
          if (scrollPos >= sectionTop - 30 && scrollPos < sectionBottom + 30) {
            const link = document.querySelector(
              `.link-section[data-name="#${section.id}"]`
            )
            if (link) {
              setActiveId(section.id)
            }
          }
        })
      }
    }
    window.addEventListener('scroll', handleScroll)

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])
  return (
    <section
      id={data._id}
      className={`${data?.type} ${
        data?.hideBot ? '' : 'pb-[20px]'
      } sticky top-[58px] z-[39]`}
    >
      <div className='max-w-full overflow-x-auto bg-white shadow'>
        <div className='flex flex-nowrap justify-center'>
          {data &&
            data.data.map((e, i) => {
              return (
                <div
                  className={`link-section flex h-[84px] max-w-[110px] flex-[0_0_110px] cursor-pointer flex-col items-center justify-between p-2.5 ${
                    e.anchor == activeId
                      ? 'bg-red-600 font-bold text-white'
                      : 'text-dark-900'
                  }`}
                  key={i}
                  data-name={`#${e.anchor}`}
                  onClick={() => scrollToHash(e.anchor)}
                >
                  <Image
                    src={e.image || ''}
                    alt={getTranslate(e.name)}
                    width={32}
                    height={32}
                    className={`${
                      e.anchor == activeId ? 'hidden' : ''
                    } mt-[4px] h-[32px] w-[32px] object-contain`}
                    loading='lazy'
                  />
                  <Image
                    src={e.activeImage || ''}
                    alt={getTranslate(e.name)}
                    width={32}
                    height={32}
                    className={`${
                      e.anchor !== activeId ? 'hidden' : ''
                    } mt-[4px] h-[32px] w-[32px] object-contain`}
                    loading='lazy'
                  />
                  <p className='text-center text-xs'>{getTranslate(e.name)}</p>
                </div>
              )
            })}
        </div>
      </div>
    </section>
  )
}

export default ModuleTabScroll
